import { createFileRoute, redirect } from '@tanstack/react-router';
import { SheetTabPage } from '@/features/sync/SheetTabPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { legacyCompareRedirect, syncSearchSchema } from '@/features/sync/syncSearch';

export const Route = createFileRoute('/_authenticated/people/sheet')({
  validateSearch: syncSearchSchema,
  beforeLoad: ({ search }) => {
    if (legacyCompareRedirect(search, '/people/review')) throw redirect({ to: '/people/review', search: { f: search.f, s: search.s }, replace: true });
  },
  component: function PeopleSheet() {
    const navigate = Route.useNavigate();
    return <SheetTabPage config={SHEET_TABS.hr} onScanned={() => void navigate({ to: '/people/review' })} />;
  },
});
